export const calculateTotalPortfolioRaise = (portfolio) => portfolio.reduce((acc, curr) => acc + curr.currentRaiseSize, 0);
export const calculateTotalPortfolioCommitted = (portfolio) => portfolio.reduce((acc, curr) => acc + curr.amountCommitted, 0);
